// Actions
const FETCH_DETECT_STREAMS = 'zen/DetectSettings/FETCH_DETECT_STREAMS';
const FETCH_DETECT_STREAMS_SUCCEEDED = 'zen/DetectSettings/FETCH_DETECT_STREAMS_SUCCEEDED';
const FETCH_DETECT_STREAMS_FAILED = 'zen/DetectSettings/FETCH_DETECT_STREAMS_FAILED';

const FETCH_CAMPAIGN = 'zen/DetectSettings/FETCH_CAMPAIGN';
const FETCH_CAMPAIGN_SUCCEEDED = 'zen/DetectSettings/FETCH_CAMPAIGN_SUCCEEDED';
const FETCH_CAMPAIGN_FAILED = 'zen/DetectSettings/FETCH_CAMPAIGN_FAILED';

const UPDATE_CAMPAIGN = 'zen/DetectSettings/UPDATE_CAMPAIGN';
const UPDATE_CAMPAIGN_SUCCEEDED = 'zen/DetectSettings/UPDATE_CAMPAIGN_SUCCEEDED';
const UPDATE_CAMPAIGN_FAILED = 'zen/DetectSettings/UPDATE_CAMPAIGN_FAILED';

export const initialState = {
  detectStreamsList: [],
  campaign: {},
  fetchingDetectStreams: true,
  fetchingCampaign: true,
  updatingCampaign: false,
};

// Reducer
// eslint-disable-next-line complexity
const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_DETECT_STREAMS:
      return {...state, fetchingDetectStreams: true};
    case FETCH_DETECT_STREAMS_SUCCEEDED:
      return {...state, detectStreamsList: action.payload, fetchingDetectStreams: false};
    case FETCH_DETECT_STREAMS_FAILED:
      return {...state, fetchingDetectStreams: false};
    case FETCH_CAMPAIGN:
      return {...state, fetchingCampaign: true};
    case FETCH_CAMPAIGN_SUCCEEDED:
      return {...state, campaign: action.payload, fetchingCampaign: false};
    case FETCH_CAMPAIGN_FAILED:
      return {...state, fetchingCampaign: false};
    case UPDATE_CAMPAIGN:
      return {...state, updatingCampaign: true};
    case UPDATE_CAMPAIGN_SUCCEEDED:
      return {...state, updatingCampaign: false, campaign: action.payload};
    case UPDATE_CAMPAIGN_FAILED:
      return {...state, updatingCampaign: false};
    default: return state;
  }
};

// Action Creators
const fetchDetectStreams = () => {
  return { type: FETCH_DETECT_STREAMS };
};

const fetchDetectStreamsSucceeded = (payload) => {
  return { type: FETCH_DETECT_STREAMS_SUCCEEDED, payload };
};

const fetchDetectStreamsFailed = () => {
  return { type: FETCH_DETECT_STREAMS_FAILED };
};

const fetchCampaign = (payload) => {
  return { type: FETCH_CAMPAIGN, payload };
};

const fetchCampaignSucceeded = (payload) => {
  return { type: FETCH_CAMPAIGN_SUCCEEDED, payload };
};

const fetchCampaignFailed = () => {
  return { type: FETCH_CAMPAIGN_FAILED };
};

const updateCampaign = (payload) => {
  return { type: UPDATE_CAMPAIGN, payload };
};

const updateCampaignSucceeded = (payload) => {
  return { type: UPDATE_CAMPAIGN_SUCCEEDED, payload };
};

const updateCampaignFailed = () => {
  return { type: UPDATE_CAMPAIGN_FAILED };
};

export default reducer;
export {
  // Actions
  FETCH_DETECT_STREAMS,
  FETCH_DETECT_STREAMS_SUCCEEDED,
  FETCH_DETECT_STREAMS_FAILED,
  FETCH_CAMPAIGN,
  FETCH_CAMPAIGN_SUCCEEDED,
  FETCH_CAMPAIGN_FAILED,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_SUCCEEDED,
  UPDATE_CAMPAIGN_FAILED,
  // Action Creators
  fetchDetectStreams,
  fetchDetectStreamsSucceeded,
  fetchDetectStreamsFailed,
  fetchCampaign,
  fetchCampaignSucceeded,
  fetchCampaignFailed,
  updateCampaign,
  updateCampaignSucceeded,
  updateCampaignFailed,
};
